import { createSlice } from '@reduxjs/toolkit'

import api, { createWrappedAsyncThunk } from 'src/api'

export const initialState = {
  customerAgreement: null,
  customerAgreements: [],
}

const SLICE_NAME = 'supplier/customers'

export const fetchCustomerAgreements = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchCustomerAgreements`,
  section => api.get(`/supplier/agreements/${section}/`)
)

export const fetchSingleCustomerAgreement = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchSingleCustomerAgreement`,
  id => api.get(`/supplier/agreements/${id}/`)
)

export const updateCustomerAgreement = createWrappedAsyncThunk(
  `${SLICE_NAME}/fetchSingleCustomerAgreement`,
  ({ id, params }) => api.put(`/supplier/agreements/${id}/`, { body: params })
)

const slice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: {
    [fetchCustomerAgreements.fulfilled]: (state, { payload }) => {
      state.customerAgreements = payload
      return state
    },
    [fetchSingleCustomerAgreement.fulfilled]: (state, { payload }) => {
      state.customerAgreement = payload
      return state
    },
    [updateCustomerAgreement.fulfilled]: (state, { payload }) => {
      state.customerAgreement = payload
      return state
    },
  },
})

export default slice.reducer
